import { LayoutView } from 'marionette';
import BaseViewMixin from 'app/src/views/base/BaseViewMixin';

export default LayoutView.extend(BaseViewMixin);
